import React, { useState } from 'react';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  fallbackSrc?: string;
  onError?: () => void;
  onLoad?: () => void;
}

export const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt,
  className = '',
  fallbackSrc = 'https://placehold.co/200x200/252B36/00B6F0?text=ARENA',
  onError,
  onLoad
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      console.log(`❌ Erro ao carregar imagem: ${src}`);
      setHasError(true);
      setImgSrc(fallbackSrc);
      if (onError) onError();
    }
  };

  const handleLoad = () => {
    console.log(`✅ Imagem carregada com sucesso: ${imgSrc}`);
    if (onLoad) onLoad();
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
    />
  );
};

